import { render, staticRenderFns } from "./ColaboradorResumo.vue?vue&type=template&id=cc2bcefc&scoped=true&"
import script from "./ColaboradorResumo.vue?vue&type=script&lang=js&"
export * from "./ColaboradorResumo.vue?vue&type=script&lang=js&"
import style0 from "./ColaboradorResumo.vue?vue&type=style&index=0&id=cc2bcefc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc2bcefc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMain } from 'vuetify/lib/components/VMain';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VChip,VCol,VIcon,VMain,VRow,VSpacer})
